import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from "../views/LandingPage.vue";
import Contractor from "../views/Contractor.vue";
import Main from "../views/Main.vue";
import Today from "../views/Today.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "landingpage",
        component: LandingPage,
    },
    //404
    {
        path: "/error",
        name: "error",
        component: () => import("../views/Error.vue"),
    },
    {
        path: "/registered",
        name: "registered",
        component: Contractor,
    },
    //承攬商管理介面
    {
        path: "/contractor",
        component: Main,
        name: "contractor",
        children: [
            {
                path: "",
                component: () =>
                    import("../components/contractor/LoginInformation.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "notice",
                name: "notice",
                component: () =>
                    import("../components/contractor/AllNotice.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "employee",
                component: () =>
                    import("../components/contractor/Employee.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "addemployee",
                component: () =>
                    import("../components/contractor/AddEmployee.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "registered",
                component: () =>
                    import("../components/contractor/TotalRegistered.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: false,
                },
            },
            {
                path: "password",
                component: () =>
                    import("../components/contractor/Password.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "test",
                component: () =>
                    import("../components/contractor/TestPage.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "test_page",
                name: "test_page",
                component: () => import("../components/contractor/Test.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "instruction",
                name: "instruction",
                component: () =>
                    import("../components/contractor/Instruction.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "contact",
                name: "contact",
                component: () => import("../components/contractor/contact.vue"),
                meta: {
                    requireAuth: true,
                    role: "contractor",
                    pass: true,
                },
            },
            {
                path: "construction",
                name: "construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "contractor", pass: true },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/construction/Construction.vue"
                            ),
                        meta: {
                            requireAuth: true,
                            role: "contractor",
                            pass: true,
                        },
                    },
                    {
                        path: "apply",
                        name: "construction_applyConstruction",
                        component: () =>
                            import(
                                "../components/contractor/ApplyConstruction.vue"
                            ),
                        meta: {
                            requireAuth: true,
                            role: ["contractor"],
                            pass: false,
                        },
                    },
                ],
            },
            {
                path: "new_construction",
                name: "new_construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "contractor", pass: true },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/new_construction/ConstructionIndex.vue"
                            ),
                        meta: {
                            requireAuth: true,
                            role: "contractor",
                            pass: true,
                        },
                    },
                ],
            },
            {
                //原事業單位施工單
                path: "enterprise",
                name: "enterprise",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "contractor" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/enterprise/Construction.vue"
                            ),
                        meta: { requireAuth: true, role: "contractor" },
                    },
                    {
                        path: "apply",
                        name: "enterprise_contractor_applyConstruction",
                        component: () =>
                            import(
                                "../components/enterprise/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["contractor"] },
                    },
                ],
            },
        ],
    },
    //工安管理介面
    {
        path: "/admin",
        name: "admin",
        component: Main,
        children: [
            {
                //Admin首頁
                path: "",
                component: () =>
                    import("../components/admin/LoginInformation.vue"),
                meta: {
                    requireAuth: true, //需身份驗證
                    role: "manager", //身份為manager
                },
            },
            {
                path: "review",
                component: () =>
                    import("../components/admin/ReviewContractor.vue"),
                meta: {
                    requireAuth: true,
                    role: "manager",
                },
            },
            {
                //AdminMenu - 新增承攬商
                path: "add_contractor",
                component: () =>
                    import("../components/admin/AddContractor.vue"),
                meta: {
                    requireAuth: true,
                    role: "manager",
                },
            },
            {
                //AdminMenu - 承攬商列表
                path: "contractor_list",
                component: () => import("../components/Transform.vue"),
                meta: {
                    requireAuth: true,
                    role: "manager",
                },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/ContractorList.vue"),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                    {
                        path: "contractor_employee",
                        name: "contractor_employee",
                        component: () =>
                            import("../components/contractor/Employee.vue"),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                    {
                        path: "contractor_data",
                        name: "contractor_data",
                        component: () =>
                            import(
                                "../components/contractor/TotalRegistered.vue"
                            ),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                    {
                        path: "contractor_employee_detail",
                        name: "contractor_employee_detail",
                        component: () =>
                            import("../components/contractor/AddEmployee.vue"),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                    {
                        path: "contractor_department",
                        name: "contractor_department",
                        component: () =>
                            import("../components/admin/DepartmentManage.vue"),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                ],
            },
            {
                //AdminMenu - 教材和試題
                path: "course",
                component: () => import("../components/Transform.vue"),
                meta: {
                    requireAuth: true,
                    role: "manager",
                },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/CourseList.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "course_detailed",
                        name: "course_detailed",
                        component: () =>
                            import("../components/admin/AddCourse.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 維護 - 公告維護
                path: "notice",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/NoticeList.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "notice_detailed",
                        name: "notice_detailed",
                        component: () =>
                            import("../components/admin/AddNotice.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 維護 - 文件維護
                path: "paper",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/PaperList.vue"),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                    {
                        path: "paper_detailed",
                        name: "paper_detailed",
                        component: () =>
                            import("../components/admin/AddPaper.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 維護 - 使用手冊維護
                path: "guard",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/GuardList.vue"),
                        meta: {
                            requireAuth: true,
                            role: "manager",
                        },
                    },
                    {
                        path: "paper_detailed",
                        name: "paper_detailed",
                        component: () =>
                            import("../components/admin/AddPaper.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            // {
            //   path: 'construction_',
            //   component: () => import('../components/Transform.vue'),
            //   meta: { requireAuth: true, role: "manager" },
            //   children: [
            //     {
            //       path: "",
            //       component: () => import('../components/admin/ConstructionList.vue'),
            //       meta: { requireAuth: true, role: "manager" },
            //     },
            //     {
            //       path: "construction_detailed",
            //       name: "construction_detailed",
            //       component: () => import('../components/admin/AddConstruction.vue'),
            //       meta: { requireAuth: true, role: "manager" },
            //     },
            //   ]
            // },
            // {
            //   path: 'newconstruction',
            //   component: () => import('../components/Transform.vue'),
            //   meta: { requireAuth: true, role: "manager" },
            //   children: [
            //     {
            //       path: "",
            //       component: () => import('../components/admin/Construction.vue'),
            //       meta: { requireAuth: true, role: "manager" },
            //     },
            //     {
            //       path: "construction_detailed",
            //       name: "construction_detailed",
            //       component: () => import('../components/admin/AddConstruction.vue'),
            //       meta: { requireAuth: true, role: "manager" },
            //     },
            //   ]
            // },
            {
                //AdminMenu - 維護 - 部門人員維護
                path: "department_maintain",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/admin/DepartmentMaintainList.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "maintain_detailed",
                        name: "maintain_detailed",
                        component: () =>
                            import("../components/admin/AddDepartment.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 維護 - 工作區域維護
                path: "location",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/Location.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "loaction_detailed",
                        name: "loaction_detailed",
                        component: () =>
                            import("../components/admin/AddLocation.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 原.工程單
                path: "engineering",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/construction/Engineering.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "apply",
                        name: "manager_applyEngineering",
                        component: () =>
                            import(
                                "../components/department/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 原.施工單
                path: "construction",
                name: "construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/construction/Construction.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "apply",
                        name: "manager_applyConstruction",
                        component: () =>
                            import(
                                "../components/contractor/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["manager"] },
                    },
                ],
            },
            {
                //新增到AdminMenu 新施工單（合併原.工程單與施工單）
                path: "new_construction",
                name: "new_construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/new_construction/ConstructionIndex.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "apply",
                        name: "new_manager_applyConstruction",
                        component: () =>
                            import(
                                "../components/new_construction/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["manager"] },
                    },
                ],
            },
            {
                //完工單（for new_construction）
                path: "new_construction_finished",
                name: "new_construction_finished",
                component: () => import("../components/Transform.vue"),
                meta: {
                    requireAuth: { requireAuth: true, role: ["manager"] },
                },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/admin/FinishedConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 緊急施工單
                path: "urgent",
                name: "urgent",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/construction/Urgent.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "apply",
                        name: "manager_applyUrgent",
                        component: () =>
                            import(
                                "../components/contractor/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //原事業單位施工單
                path: "enterprise",
                name: "enterprise",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/enterprise/Construction.vue"
                            ),
                        meta: { requireAuth: true, role: "manager" },
                    },
                    {
                        path: "apply",
                        name: "enterprise_manager_applyConstruction",
                        component: () =>
                            import(
                                "../components/enterprise/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["manager"] },
                    },
                ],
            },
            {
                //AdminMenu - 清潔保全協議組織及合約
                path: "safety-sheet",
                name: "safety-sheet",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/SafetySheet.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 上傳施工單紙本
                path: "sheet",
                name: "sheet",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/UploadSheet.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
            {
                //AdminMenu - 維護
                path: "guard-sheet",
                name: "guard-sheet",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "manager" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/GuardSheet.vue"),
                        meta: { requireAuth: true, role: "manager" },
                    },
                ],
            },
        ],
    },
    //需求單位管理介面
    {
        path: "/department",
        name: "department",
        component: Main,
        children: [
            {
                path: "",
                component: () =>
                    import("../components/department/LoginInformation.vue"),
                meta: { requireAuth: true, role: "department" },
            },
            {
                path: "contractor_list",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/admin/ContractorList.vue"),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "department_contractor_employee",
                        name: "department_contractor_employee",
                        component: () =>
                            import("../components/contractor/Employee.vue"),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "department_contractor_data",
                        name: "department_contractor_data",
                        component: () =>
                            import(
                                "../components/contractor/TotalRegistered.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "department_contractor_employee_detail",
                        name: "department_contractor_employee_detail",
                        component: () =>
                            import("../components/contractor/AddEmployee.vue"),
                        meta: { requireAuth: true, role: "department" },
                    },
                ],
            },
            {
                path: "department_maintain",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/admin/DepartmentMaintainList.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "maintain_detailed",
                        name: "maintain_detailed",
                        component: () =>
                            import("../components/admin/AddDepartment.vue"),
                        meta: { requireAuth: true, role: "department" },
                    },
                ],
            },
            {
                path: "department_password",
                component: () =>
                    import("../components/department/Password.vue"),
                meta: { requireAuth: true, role: "department" },
            },
            {
                path: "instruction",
                name: "instruction",
                component: () =>
                    import("../components/contractor/Instruction.vue"),
                meta: { requireAuth: true, role: "department" },
            },
            {
                path: "de_construction",
                name: "de_construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/department/Construction.vue"),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply",
                        name: "de_applyConstruction",
                        component: () =>
                            import(
                                "../components/department/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply_daily",
                        name: "applyConstruction",
                        component: () =>
                            import(
                                "../components/contractor/ApplyConstruction.vue"
                            ),
                        meta: {
                            requireAuth: true,
                            role: ["department"],
                            pass: false,
                        },
                    },
                ],
            },
            {
                path: "engineering",
                name: "engineering",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/construction/Engineering.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply",
                        name: "department_applyEngineering",
                        component: () =>
                            import(
                                "../components/department/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    // {
                    //   path: "apply_daily",
                    //   name: "applyConstruction",
                    //   component: () => import('../components/contractor/ApplyConstruction.vue'),
                    //   meta: { requireAuth: true, role: ["department"], pass: false },
                    // },
                ],
            },
            {
                path: "construction",
                name: "construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/construction/Construction.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply",
                        name: "department_applyConstruction",
                        component: () =>
                            import(
                                "../components/contractor/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["department"] },
                    },
                ],
            },
            {
                path: "new_construction",
                name: "new_construction",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/new_construction/ConstructionIndex.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply",
                        name: "new_department_applyConstruction",
                        component: () =>
                            import(
                                "../components/new_construction/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["department"] },
                    },
                ],
            },
            {
                //完工單（for new_construction）
                path: "new_construction_finished",
                name: "new_construction_finished",
                component: () => import("../components/Transform.vue"),
                meta: {
                    requireAuth: { requireAuth: true, role: ["department"] },
                },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/admin/FinishedConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                ],
            },

            {
                path: "urgent",
                name: "urgent",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../components/construction/Urgent.vue"),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply",
                        name: "department_applyUrgent",
                        component: () =>
                            import(
                                "../components/contractor/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                ],
            },
            {
                //原事業單位施工單
                path: "enterprise",
                name: "enterprise",
                component: () => import("../components/Transform.vue"),
                meta: { requireAuth: true, role: "department" },
                children: [
                    {
                        path: "",
                        component: () =>
                            import(
                                "../components/enterprise/Construction.vue"
                            ),
                        meta: { requireAuth: true, role: "department" },
                    },
                    {
                        path: "apply",
                        name: "enterprise_department_applyConstruction",
                        component: () =>
                            import(
                                "../components/enterprise/ApplyConstruction.vue"
                            ),
                        meta: { requireAuth: true, role: ["department"] },
                    },
                ],
            },
        ],
    },
    // for 原來的施工單使用
    {
        path: "/paper",
        name: "paper",
        component: () => import("../components/paper/Paper.vue"),
        children: [
            {
                path: "commit",
                name: "commit",
                component: () => import("../components/paper/Commit.vue"),
                meta: {
                    requireAuth: false,
                },
            },
            {
                path: "toolbox",
                name: "toolbox",
                component: () => import("../components/paper/DailyDanger.vue"),
                meta: {
                    requireAuth: false,
                },
            },
        ],
    },
    // for new_work 使用
    {
        path: "/card",
        name: "card",
        component: () => import("../views/Card.vue"),
        meta: { requireAuth: true, role: "manager" },
    },
    {
        path: "/score",
        name: "score",
        component: () => import("../views/Score.vue"),
        meta: { requireAuth: true, role: "contractor", pass: true },
    },
    {
        path: "/new_paper",
        name: "new_paper",
        component: () => import("../components/new_paper/Paper.vue"),
        children: [
            {
                path: "new_commit",
                name: "new_commit",
                component: () => import("../components/new_paper/Commit.vue"),
                meta: {
                    requireAuth: false,
                },
            },
            {
                path: "new_toolbox",
                name: "new_toolbox",
                component: () =>
                    import("../components/new_paper/DailyDanger.vue"),
                meta: {
                    requireAuth: false,
                },
            },
        ],
    },
    {
        path: "/print",
        name: "print",
        component: () => import("../views/Print.vue"),
    },
    //2024/4/8 切換
    // {
    //     path: "/guide",
    //     name: "guide",
    //     component: () => import("../views/Guide.vue"),
    // },
    //新版入廠介面
    {
        path: "/guide",
        name: "guide",
        component: () => import("../views/NewGuide.vue"),
        // meta: {
        //     keepAlive: true, // 需要被緩存
        // },
    },
    {
        path: "/test",
        name: "test",
        component: () => import("../views/TestPage.vue"),
    },
    {
        path: "/today",
        name: "today",
        component: Today,
        children: [
            {
                path: "",
                component: () =>
                    import("../components/admin/LoginInformation.vue"),
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
